import React, { useCallback, useEffect } from "react";

// components
import TextInput from "../../../component/element/forms/TextInput";
import Modal from "../../../component/ui/modal";
import { toast } from "sonner";

// constants and icon
import { ICreateRequestPrice } from "../../../store/types/request";
import { useAppSelector } from "../../../store";

type IEditPrice = {
  id: string;
  visible: boolean;
  title?: string;
  requirePaymentLink?: boolean;
  initialData?: {
    price: string;
    payment_link: string;
  };
  onCloseView: (data: ICreateRequestPrice) => void;
};

export const EditPrice: React.FC<IEditPrice> = ({
  id,
  visible,
  title = "Edit Price",
  requirePaymentLink = false,
  initialData,
  onCloseView,
}) => {
  const loading = useAppSelector(({ request }) => request.update ?? false);
  const [data, dataSet] = React.useState<ICreateRequestPrice>({
    request_id: Number(id),
    price: "",
    payment_link: null,
  });

  const onLoad = useCallback(() => {
    dataSet({
      request_id: Number(id),
      price: initialData?.price || "",
      payment_link: initialData?.payment_link || null,
    });
  }, [id, initialData?.payment_link, initialData?.price]);

  useEffect(() => {
    if (visible) {
      onLoad();
    }
  }, [onLoad, visible]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    const newData = {
      request_id: 0,
      price: "",
      payment_link: null,
    };
    onCloseView(newData);
    dataSet(newData);
  };

  const handleSubmit = () => {
    if (requirePaymentLink && !data.payment_link?.trim()) {
      toast.error("Payment link is required to update a price.");
      return;
    }

    onCloseView(data);
  };

  if (!visible) return null;

  return (
    <Modal
      title={title}
      open={visible}
      onClose={handleClose}
      onOkClick={handleSubmit}
      isLoading={loading}
    >
      <div className="w-full space-y-6">
        <TextInput
          type="text"
          label="Price"
          placeholder="Enter Price"
          name="price"
          value={data.price}
          onChange={handleChange}
        />

        <TextInput
          type="text"
          label="Payment Link"
          placeholder="Enter Payment Link"
          name="payment_link"
          value={data.payment_link ?? ""}
          onChange={handleChange}
          required={requirePaymentLink}
        />
      </div>
    </Modal>
  );
};
